import { inject, provide } from 'vue';

// FIXME: nuxt3移行後はuseStateを使う
const IS_IN_IFRAME_INJECTION_KEY: unique symbol = Symbol(
  'isInIframe Injection Key'
);

export const useIsInIframe = () => {
  const isInIframe = inject(IS_IN_IFRAME_INJECTION_KEY, false);

  return { isInIframe };
};

export const useSetIsInIframe = () => {
  provide(IS_IN_IFRAME_INJECTION_KEY, true);
};
